module.exports = "/_next/static/images/tv-up-uv-fc0c98df481a2aa65db9b7fde33b7ccd.png";